import React, { useEffect, useState } from 'react';
import { Download } from 'lucide-react';

/**
 * A small persistent button that re-triggers the PWA install prompt.
 * Hides itself when the app is already running as an installed PWA.
 */
export default function InstallAppButton({ className = '', label = true }) {
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    const inStandalone =
      window.matchMedia('(display-mode: standalone)').matches ||
      window.navigator.standalone === true;
    setHidden(inStandalone);
  }, []);

  if (hidden) return null;

  const handleClick = () => {
    // Clear prior dismissal so the prompt shows again immediately
    localStorage.removeItem('pwa-install-dismissed');
    window.dispatchEvent(new CustomEvent('evabrew-show-install-prompt'));
  };

  return (
    <button
      onClick={handleClick}
      data-testid={label ? 'sidebar-install-button' : 'header-install-button'}
      title="Install app"
      className={
        className ||
        'w-full flex items-center justify-center space-x-2 px-3 py-2 bg-white/15 text-white rounded-lg text-sm font-medium hover:bg-white/25 transition'
      }
    >
      <Download className="w-4 h-4" />
      {label && <span>Install App</span>}
    </button>
  );
}
